// @flow
import React, { useState, useCallback } from 'react';

import { goBack } from '../../lib/helpers';
import { washingFrequencyApi } from '../../lib/api';
import { type WashingFrequency } from '../../lib/types';

import CommonCardPage from '../../components/hoc/common/handbook/CardPage';
import { InnerForm } from './components';
import { getBreadCrumbsByUrlForEdit } from '../../lib/autoBreadcrumbs';

type PageProps = {
  id: number
};

const entryPointPath = '/admin/washing-frequency/';

export default (props: PageProps) => {
  const [data: WashingFrequency, setData] = useState({
    id: props.id,
    internalWashingMonths: []
  });

  const breadCrumbs = getBreadCrumbsByUrlForEdit(entryPointPath, data.id);

  const onFetch = useCallback(async () => {
    !!props.id && setData(await washingFrequencyApi.get(props.id));
  }, [props.id]);

  const onSubmit = async (payload: WashingFrequency) => {
    let id = payload.id;
    if (id) {
      await washingFrequencyApi.update(payload);
    } else {
      let data = await washingFrequencyApi.add(payload);
      id = data.id;
    }
    await goBack(`${entryPointPath}${id}`);
  };

  const onCancel = async (payload: WashingFrequency) => {
    if (data.id) {
      await goBack(`${entryPointPath}${data.id}`);
    } else await goBack(`${entryPointPath}`);
  };

  return (
    <CommonCardPage
      pageHeaderProps={{
        breadCrumbs,
        mainHeader: 'Периодичность проведения моек'
      }}
      onFetch={onFetch}
      onSubmit={onSubmit}
      onCancel={onCancel}
    >
      <InnerForm data={data} useFooter noWrapMe />
    </CommonCardPage>
  );
};
